import React from "react";

interface IProps {
  theme?: "light" | "dark" 
}

export const SpiralIcon = ({theme}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.5592 4C10.0044 4 9.65977 4.60297 9.9413 5.08102C10.2186 5.55199 10.8998 5.55199 11.1772 5.08102C11.4587 4.60297 11.114 4 10.5592 4Z"
        fill={theme === "light" ? "black" : "white"}
      />
      <path
        d="M12.9332 11.1087C12.7619 10.7277 12.4939 10.4177 12.1706 10.194C11.5569 9.76939 10.8979 10.3981 10.8979 11.1444C10.8979 11.678 10.5818 12.1608 10.0927 12.3742L9.33629 12.7043C8.20457 13.1959 7.69573 14.4896 8.18702 15.6022C8.35942 15.9856 8.62786 16.2953 8.95278 16.5173C9.56626 16.9363 10.2224 16.3069 10.2224 15.5639C10.2224 15.032 10.5379 14.5508 11.0258 14.3389L11.8103 13.998C12.9245 13.515 13.4333 12.2213 12.9332 11.1087Z"
        fill={theme === "light" ? "black" : "white"}
      />
      <path
        d="M12.9334 16.1946C12.7619 15.8133 12.4935 15.503 12.1698 15.2793C11.5564 14.8553 10.898 15.4835 10.898 16.2292C10.898 16.7633 10.581 17.2464 10.0911 17.459L9.32766 17.7902C8.20472 18.2818 7.69588 19.5755 8.18717 20.6881C8.35957 21.0715 8.62801 21.3812 8.95293 21.6032C9.56641 22.0223 10.2225 21.3928 10.2225 20.6499C10.2225 20.118 10.5381 19.6368 11.0259 19.4248L11.8104 19.0839C12.9246 18.5923 13.4334 17.2986 12.9334 16.1946Z"
        fill={theme === "light" ? "black" : "white"}
      />
      <path
        d="M13.6719 8.15641C15.4195 7.40478 13.4088 5.90258 11.664 6.66041L9.31174 7.68204C8.19756 8.18228 7.6975 9.46738 8.18879 10.5714C8.36011 10.9523 8.62624 11.2605 8.94752 11.4822C9.55898 11.9041 10.2154 11.2761 10.2154 10.5332C10.2154 10.0013 10.5311 9.52007 11.019 9.30822L13.6719 8.15641ZM13.8737 6.70744C13.7333 6.76781 13.5754 6.70744 13.514 6.56944C13.4526 6.43145 13.514 6.2762 13.6544 6.21582C13.7948 6.15545 13.9527 6.21582 14.0141 6.35382C14.0755 6.48319 14.0141 6.64707 13.8737 6.70744Z"
        fill={theme === "light" ? "black" : "white"}
      />
    </svg>
  );
};
